import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './admin.css';

const NAV = [
  { section: 'Overview' },
  { to: '/admin', label: '📊 Dashboard', exact: true },
  { to: '/admin/inquiries', label: '📩 Inquiries' },
  { section: 'Gallery' },
  { to: '/admin/banners', label: '🖼 Home Banners' },
  { to: '/admin/galleries', label: '📷 Service Galleries' },
  { to: '/admin/ourwork', label: '🎬 Our Work' },
  { to: '/admin/vanity', label: '✨ Vanity Images' },
  { to: '/admin/instagram', label: '📸 Instagram Posts' },
  { section: 'Community' },
  { to: '/admin/testimonials', label: '💬 Testimonials' },
  { to: '/admin/faqs', label: '❓ FAQs' },
  { to: '/admin/passcodes', label: '🔐 Passcodes' },
  { section: 'Content' },
  { to: '/admin/home-content', label: '🏠 Home Content' },
  { to: '/admin/about-content', label: 'ℹ️ About Content' },
  { to: '/admin/blogs', label: '✍️ Blog Posts' },
];

export default function AdminLayout({ title, children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/admin/login');
  };

  return (
    <div className="admin-root">
      <div className="admin-layout">
        <aside className={`admin-sidebar${sidebarOpen ? ' open' : ''}`}>
          <div className="admin-sidebar-brand">
            <h3>Atelier by Shriji</h3>
            <p>Admin Panel</p>
          </div>
          <nav>
            {NAV.map((item, i) =>
              item.section ? (
                <div key={i} className="admin-sidebar-section">{item.section}</div>
              ) : (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.exact}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={() => setSidebarOpen(false)}
                >
                  {item.label}
                </NavLink>
              )
            )}
          </nav>
          <div className="admin-sidebar-bottom">
            <button onClick={handleLogout}>🚪 Logout</button>
          </div>
        </aside>

        <div className="admin-main">
          <div className="admin-topbar">
            <h1>{title}</h1>
            <button className="a-btn-icon menu-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
          </div>
          <div className="admin-content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
